module.exports = __webpack_public_path__ + "static/assets/83dd62c9b8fe57c2593672212bc09951.png";